import { iconMap } from '@/pages/Products/VpsOciDetailPage/icons/iconMap';

export const getIconBySlug = (slug) => {
  const lowerSlug = slug.toLowerCase();

  if (iconMap[lowerSlug]) {
    return iconMap[lowerSlug];
  }

  const matchingKey = Object.keys(iconMap).find(key => lowerSlug.includes(key.toLowerCase()));
  return matchingKey ? iconMap[matchingKey] : null;
};
